import { render } from "./index.vue?vue&type=template&id=204d240e"
import script from "./script.js?vue&type=script&lang=js"
export * from "./script.js?vue&type=script&lang=js"

import "./style.less?vue&type=style&index=0&lang=less"
import "./print.less?vue&type=style&index=1&lang=less"
script.render = render

export default script